/**
 * Validation utilities for form inputs
 */

/**
 * Validate email format
 * @param {string} email 
 * @returns {boolean}
 */
export function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

/**
 * Validate password strength
 * @param {string} password 
 * @returns {boolean} true if password is at least 8 characters
 */
export function validatePassword(password) {
    return password && password.length >= 8;
}

/**
 * Validate username format
 * @param {string} username 
 * @returns {boolean} true if username is alphanumeric and at least 3 characters
 */
export function validateUsername(username) {
    const usernameRegex = /^[a-zA-Z0-9_]{3,}$/;
    return usernameRegex.test(username);
}

/**
 * Get password strength level
 * @param {string} password 
 * @returns {string} 'weak' | 'medium' | 'strong'
 */
export function getPasswordStrength(password) {
    if (!password) return 'weak';

    let strength = 0;

    // Length check
    if (password.length >= 8) strength++;
    if (password.length >= 12) strength++;

    // Character variety checks
    if (/[a-z]/.test(password)) strength++; // lowercase
    if (/[A-Z]/.test(password)) strength++; // uppercase
    if (/[0-9]/.test(password)) strength++; // numbers
    if (/[^a-zA-Z0-9]/.test(password)) strength++; // special chars

    if (strength <= 2) return 'weak';
    if (strength <= 4) return 'medium';
    return 'strong';
}

/**
 * Validate required field
 * @param {string} value 
 * @returns {boolean}
 */
export function validateRequired(value) {
    return value && value.trim().length > 0;
}
